import { useDispatch } from 'react-redux'
import { Drawer } from 'antd'
import React from 'react'
import { userActions } from '../../../../../store/slices/user.slice'
import InviteUserForm from './InviteUserForm'

const InviteUserDrawer = () => {
    const dispatch = useDispatch()

    const handleClose = () => dispatch(userActions.setShowInviteUserDrawer(false))

    return (
        <Drawer title='Invite User' autoFocus onClose={handleClose} open width={560} destroyOnClose mask={null}>
            <InviteUserForm onSuccess={handleClose} />
        </Drawer>
    )
}

export default InviteUserDrawer
